import { Box, Grid, Typography } from '@mui/material'
import MainLayout from '../components/MainLayout'
import ContactMe from '../components/ContactMe'
import styled from '@emotion/styled/macro'
// image
import banner from '../assets/products/00產品介紹BN.png'
import img3cElec from '../assets/products/01_3CElect.jpg'
import imgMetal from '../assets/products/02_mental.jpg'
import imgbuild from '../assets/products/03_build.jpg'
import imgNonDust from '../assets/products/04_non_dust.jpg'
import imgFood from '../assets/products/05_food.jpg'
import imgEleProduct from '../assets/products/06_elec.jpg'
import useRwd from '../utils/useRwd'

export default function Products() {
  const { isPhone, isToplet, isPC } = useRwd()
  const StyledSpan = styled.span`
    color: #5b5b5b;
    font-weight: bold;
  `
  const content = [
    {
      title: 'AI 瑕疵檢測方案',
      subtitle: (
        <Typography variant="subtitle1" align="justify">
          AI瑕疵檢測方案，透過 <b>AI影像辨識技術</b>
          ，協助企業快速檢測產品瑕疵，降低人工檢驗誤差，大幅提升產品出廠品質。
        </Typography>
      ),
      list: [
        {
          tech: '深度學習模型，準確識別微小瑕疵',
          benifit: '檢測速度提升 3 倍',
        },
        { tech: '高準確率（99% 以上）', benifit: '產品良率提高 30%' },
        { tech: '即時異常報告，降低次品率', benifit: '降低人工成本 50%' },
      ],
      area1: '3C電子製造業',
      area1_img: img3cElec,
      area1_descript: '檢測電子零件、PCB 板等產品的瑕疵',
      area2: '金屬加工業',
      area2_img: imgMetal,
      area2_descript: '檢測金屬零件外觀瑕疵',
    },
    {
      title: 'AI 防護具檢測方案',
      subtitle: (
        <Typography variant="subtitle1" align="justify">
          AI 防護具檢測方案透過<b>即時影像辨識</b>
          ，確保員工進入作業環境時配戴完整的防護裝備，減少安全風險，提高工作場所的安全管理效率。
        </Typography>
      ),
      list: [
        {
          tech: '即時監測，確保人員安全合規',
          benifit: '降低 70% 工安違規風險，減少意外發生',
        },
        {
          tech: '高準確度影像辨識',
          benifit: '提升 50% 安全巡檢效率，減少人力需求',
        },
        {
          tech: '可與監控系統整合，提升安全管理效率',
          benifit: '確保 100% 符合防護標準，減少工安責任風險',
        },
      ],
      area1: '營造業、施工現場',
      area1_img: imgbuild,
      area1_descript: '檢測作業員安全帽、安全帶、安全背心等防護具穿戴',
      area2: '無塵工作環境',
      area2_img: imgNonDust,
      area2_descript: '檢測作業員無塵服、無塵帽、手套等穿戴',
    },
    {
      title: 'AI 產線作業 SOP 辨識方案',
      subtitle: (
        <Typography variant="subtitle1" align="justify">
          AI 產線作業 SOP
          辨識方案可自動監測生產過程，確保工人遵循標準作業程序，降低生產過程中的異常狀況，進一步減少產品不良率，提高生產一致性
        </Typography>
      ),
      list: [
        {
          tech: 'AI 自動辨識 SOP 操作，減少人為疏失',
          benifit: '降低 40% 生產異常，提升品質穩定性',
        },
        {
          tech: '即時警報功能，當 SOP 偏離標準時立即通知',
          benifit: '減少 50% 操作失誤，降低不良品',
        },
        {
          tech: '影像數據分析，提供改善依據',
          benifit: '確保 100% 標準流程執行，提升品牌信譽',
        },
      ],
      area1: '食品加工業',
      area1_img: imgFood,
      area1_descript: '確保生產流程合規，提升食品安全',
      area2: '電子製造業',
      area2_img: imgEleProduct,
      area2_descript: '檢測作業員SOP 操作正確性，減少不良品',
    },
  ]

  return (
    <>
      <MainLayout bannerFile={banner} bannerAlt="產品介紹">
        <Grid container spacing={10} textAlign="center">
          {content?.map((item, i) => (
            <Grid item xs={12} key={i}>
              <Card {...item} />
            </Grid>
          ))}
          <Grid item xs={12}>
            <ContactMe />
          </Grid>
        </Grid>
      </MainLayout>
    </>
  )
}

function Card({ ...props }) {
  const {
    title,
    subtitle,
    list,
    area1,
    area1_img,
    area1_descript,
    area2,
    area2_img,
    area2_descript,
  } = props
  const { isPC, isToplet, isPhone } = useRwd()

  const needR = isToplet || isPhone

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h3">{title}</Typography>
        </Grid>
        <Grid item xs={12}>
          <div style={{ width: '90%', margin: 'auto' }}>{subtitle}</div>
        </Grid>
        <Grid item xs={12}>
          <Typography
            variant="h4"
            style={{ marginTop: '0.5em', marginBottom: '0.5em' }}
          >
            技術特色 / 客戶收益
          </Typography>
          {list?.map((item, i) => (
            <Box
              key={i}
              style={{
                backgroundColor: '#f7f7f7',
                padding: '2em',
                width: '100%',
                marginBottom: '1em',
              }}
            >
              <Typography variant="body1" style={{ marginBottom: '0.5em' }}>
                {item.tech}
              </Typography>
              <Typography variant="body1">{item.benifit}</Typography>
            </Box>
          ))}
        </Grid>
        <Grid item xs={12}>
          <div style={{ backgroundColor: '#f7f7f7', padding: '1em 2em' }}>
            <div style={{ marginBottom: '1.5em' }}>
              <Typography variant="h4">導入場域</Typography>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: isPhone ? 'column' : 'row',
                gap: '2em',
                justifyContent: isPhone ? 'flex-start' : 'center',
                alignItems: isPhone ? 'center' : 'flex-start',
              }}
            >
              <div style={{ flex: 1 }}>
                <Typography
                  variant="body1"
                  style={{ fontWeight: 'bold', marginBottom: '1em' }}
                >
                  {area1}
                </Typography>
                <Box style={{ marginBottom: '1em' }}>
                  <img src={area1_img} alt={area1} style={{ width: '100%' }} />
                </Box>
                <Typography variant="body1" align="center">
                  {area1_descript}
                </Typography>
              </div>
              <div style={{ flex: 1 }}>
                <Typography
                  variant="body1"
                  style={{ fontWeight: 'bold', marginBottom: '1em' }}
                >
                  {area2}
                </Typography>
                <Box style={{ marginBottom: '1em' }}>
                  <img src={area2_img} alt={area2} style={{ width: '100%' }} />
                </Box>
                <Typography variant="body1" align="center">
                  {area2_descript}
                </Typography>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </>
  )
}
